module.exports = __webpack_public_path__ + "img/analysis.99d69ddc.svg";